import { render } from "./PrimaryChart.vue?vue&type=template&id=4b8afdc1&scoped=true"
import script from "./PrimaryChart.vue?vue&type=script&lang=js"
export * from "./PrimaryChart.vue?vue&type=script&lang=js"

import "./PrimaryChart.vue?vue&type=style&index=0&id=4b8afdc1&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8afdc1"]])

export default __exports__